import { render } from "./GameChat.vue?vue&type=template&id=0e0eb932&scoped=true&ts=true"
import script from "./GameChat.vue?vue&type=script&lang=ts"
export * from "./GameChat.vue?vue&type=script&lang=ts"

import "./GameChat.vue?vue&type=style&index=0&id=0e0eb932&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0eb932"]])

export default __exports__